import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 구매 확인 실패 😥 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 네고스탁에서")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 조합지분 구매 내용이 확인되지 않았어요.")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 다시 확인해주세요! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createBlock(_component_ag_content, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box, {
        my: "16px",
        style: {"flex-direction":"column"},
        dp: "flex",
        height: "100%",
        "justify-content": "center",
        "align-items": "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text, {
            py: "32px",
            "text-align": 'center',
            typography: 'tit18b'
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, {
            "text-align": 'center',
            color: 'gray2',
            typography: 'main16r'
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}